import React from "react";
import ProjectBanner from "../../layout/builders/ProjectBanner";
import Layout from "../../layout/realestateagent/Layout";
import PropertyPostComponent from "../../layout/realestateagent/HousingPost/PropertyPost";

const PropertyPost = () => {
    return (
        <div style={{ backgroundColor: "#E0E0E0" }}>
            <Layout>
                <div>
                    <ProjectBanner
                        title="Property Post"
                        subtitle="List your plots and properties"
                        imageUrl="https://via.placeholder.com/1200x300"
                    />
                </div>
                <PropertyPostComponent />
            </Layout>
        </div>
    );
};

export default PropertyPost;
